module.exports = __webpack_public_path__ + "static/media/14.23455d38.jpg";